import React from "react";
import { useNavigate } from "react-router-dom";
import NewArrowLeftIcon from "../../assets/icons/chevron-light-background.svg";

type props = {
  left?: number;
  top?: number;
  navigateTo?: string;
  color?: string;
  applyClassName?: boolean;
  callback?: Function;
  style?: Object;
  replace?: boolean;
};
const ArrowLeftIconComponent: React.FC<props> = ({
  left,
  top,
  navigateTo,
  color = "white",
  applyClassName = true,
  callback,
  style,
  replace = false,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const destination: any = navigateTo !== undefined && navigateTo !== "" ? navigateTo : -1;
    navigate(destination, { replace });
    if (callback !== undefined) {
      callback();
    }
  };

  return (
    <img
      className={applyClassName ? "header-arrow-left" : ""}
      src={NewArrowLeftIcon}
      alt="arrow left"
      style={style !== undefined ? { left: left, top: top, ...style } : { left: left, top: top }}
      onClick={handleClick}
    />
  );
};

export default ArrowLeftIconComponent;
